import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { CedProductService } from 'app/management/ced-products/ced-product.service';
import { CedProductModel } from 'app/management/ced-products/models/ced-product.model';
import { UserProfile } from 'app/_models';
import { CedConfirmDialogService, CedNotificationService } from 'ced-ng-library';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { purshaseService } from '../purshase.service';
import { serviceModel } from '../service-model';

@Component({
  selector: 'app-sale-service-details',
  templateUrl: './sale-service-details.component.html',
  styleUrls: ['./sale-service-details.component.scss']
})
export class SaleServiceDetailsComponent extends DialogContentBase implements OnInit, OnDestroy {
  public saleForm = new FormGroup({});
  private _subject$: Subject<boolean> = new Subject();
  private selectedSaleService : CedProductModel = null;
  values = [{text:"Yes",id:0},{text:"No",id:1}];
  public purshases : serviceModel[] = [];
  private profile: UserProfile = new UserProfile();
  constructor(dialog: DialogRef,
     private cedConfirmService: CedConfirmDialogService,
     private SaleService : CedProductService,
     private cedNotificationService: CedNotificationService,
     private purshaseService: purshaseService) {
    super(dialog); }

  ngOnInit() {
    this.initForm();
    this.getPurshaseServices();
    if(this.selectedSaleService != null){
    this.populateControls();
    }
  }

  initForm(){
    this.saleForm = new FormGroup({
        code: new FormControl(null, Validators.required),
        shortName: new FormControl(null, Validators.required),
        longName: new FormControl(null, Validators.required),
        purshaseService: new FormControl(null),
        active: new FormControl(null,Validators.required),
        comment: new FormControl("")
    });
  }

  populateControls(){
    if(this.selectedSaleService != null){
        this.saleForm.controls.code.setValue(this.selectedSaleService.prdCode);
        this.saleForm.controls.shortName.setValue(this.selectedSaleService.prdShortName);
        this.saleForm.controls.longName.setValue(this.selectedSaleService.prdLongName);
        if(this.selectedSaleService.prdInactive == true){
          this.saleForm.controls.active.setValue(this.values[1]);
        }else if(this.selectedSaleService.prdInactive == false){
          this.saleForm.controls.active.setValue(this.values[0]);
        }
    }                                       
 }
  public save() {
    let saleProduct = new CedProductModel (); 
    saleProduct.prdCode = this.saleForm.controls.code.value;
    saleProduct.prdShortName = this.saleForm.controls.shortName.value;
    saleProduct.prdLongName =  this.saleForm.controls.longName.value;
    saleProduct.prdInactive =  this.saleForm.controls.active.value.id;
    saleProduct.prdComment = this.saleForm.controls.comment.value;
    saleProduct.services = this.saleForm.controls.purshaseService.value;

    if(this.saleForm.valid){
        if(this.selectedSaleService == null){
          saleProduct.prdCreatedBy = this.profile.emailAddress;          
          saleProduct.prdLastModifiedBy = this.profile.emailAddress;      
          this.SaleService
          .AddByProductClassification(saleProduct)
          .pipe(takeUntil(this._subject$))
          .subscribe(
            (res:any) => {
              let existingCode = res;
              if (existingCode == true)
              {
                this.cedNotificationService.error("NOTIFICATIONS.PRODUCT_CODE_SHOULD_BE_UNIQUE")
              }
              else if (existingCode == false) {
                this.dialog.close(true);
                this.cedNotificationService.success("NOTIFICATIONS.SAVE_SUCCEDED");
              }
            }
          )
      }
      else{
        saleProduct.prdId = this.selectedSaleService.prdId;
        saleProduct.prdLastModifiedBy = this.profile.emailAddress;
        this.SaleService
        .update(saleProduct)
        .pipe(takeUntil(this._subject$))
        .subscribe(
          (res:any) => {
            let existingCode = res;
            if (existingCode == true)
            {
              this.cedNotificationService.error("NOTIFICATIONS.PRODUCT_CODE_SHOULD_BE_UNIQUE")
            }
            else if (existingCode == false) {
              this.dialog.close(true);
              this.cedNotificationService.success("NOTIFICATIONS.UPDATE_SUCCEDED");
            }
          }
        )
      }
    } 
    else
    this.cedNotificationService.error("NOTIFICATIONS.REQUIRED_DATA_MISSING")
}
  getPurshaseServices(){
        this.purshaseService.getAll()
        .pipe(takeUntil(this._subject$))
        .subscribe((data: any) => {
          this.purshases = data.filter(se => se.itmShortName != null);
          this.purshases = this.purshases.sort((a, b) => a.itmShortName.toLowerCase() > b.itmShortName.toLowerCase() ? 1 : -1);
        });
    }

  public cancel() {
    this.dialog.close(null);
  } 

  ngOnDestroy(): void {
    this._subject$.next();
    this._subject$.complete();
  }
}
